import readService from './readService';
export default {
  markAsRead({ moduleId, item }) {
    readService.markAsRead(item);
  },
  markAsUnread({ moduleId, item }) {
    readService.markAsUnread(item);
  },
  isMandatoryToRead(item) {
    return item.mandatoryToRead === 1;
  },

  isMandatoryToReadAndNotRead(item) {
    return item.mandatoryToRead === 1 && !item._userState.dateread;
  },
  isMandatoryToReadAndRead(item) {
    let isMandatoryToReadAndRead = item.mandatoryToRead === 1 && !!item._userState.dateread;
    return isMandatoryToReadAndRead;
  },
};
